import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7c2d4abc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c2d4abc')) {
      api.createRecord('7c2d4abc', component.options)
    } else {
      api.reload('7c2d4abc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7c2d4abc", function () {
      api.rerender('7c2d4abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/appManage/settings/index.vue"
export default component.exports